<template>
  <NuxtLayout>
    <div class="error-page">
      <div class="error-page__background" />

      <h1 class="error-page__code">
        {{ error.statusCode }}
      </h1>

      <TypographyComp
        preset="text-s"
        class="error-page__message"
      >
        {{ diplayedErrorMessage }}
      </TypographyComp>

      <CommonButton
        class="error-page__button"
        @click="handleButtonClick"
      >
        На главную
      </CommonButton>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import type { NuxtError } from '#app';
import { isDev } from '../config/variables';

const { error } = defineProps<{ error: NuxtError }>();

const CUSTOM_MESSAGES: {
  [key: number]: string; default: string;
} = {
  404: 'Хм, такую страницу найти не удалось.',
  default: 'Что-то пошло не так.',
};

const diplayedErrorMessage = computed(() => (
  isDev
    ? error.statusMessage
    : CUSTOM_MESSAGES[error.statusCode] || CUSTOM_MESSAGES.default
));

const handleButtonClick = () => {
  navigateTo('/');
};

onMounted(() => {
  useSentry(sentry => sentry?.captureException(error.message, { extra: { ...error } }));

  console.error({
    statusCode: error.statusCode,
    message: error.statusMessage,
  });
});
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  height: 100%;
  color: $color-white;

  &__background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/layout/background-photo.webp');
    background-size: cover;
    background-position: center;
    z-index: $z-underground;

    @include layout-aspect-mobile {
      background-image: url('@/assets/images/layout/background-photo-mobile.webp');
    }
  }

  &__code {
    text-align: center;
    font-size: 14rem;
    font-weight: 700;
    line-height: 87%;
    letter-spacing: -0.28rem;
    color: $color-white;
  }

  &__message {
    color: $color-light-red-white;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 125%;
    letter-spacing: -0.064rem;
  }

  &__button {
    width: 24rem;
    margin-top: 6.4rem;

    @include layout-aspect-mobile {
      margin-top: 4.8rem;
    }
  }
}
</style>
